import { type UserRole } from '@/db/schema/users';

export function canAccessAdminPages({ role }: { role: UserRole | undefined }) {
  return role === 'admin';
}

export function canAccessAdminContent({ role }: { role: UserRole | undefined }) {
  return role === 'admin';
}
